import axios, { getEnv } from '../../../services/api';

export const AtendimentoRecusadoService = {
  findAll: async (params, body = {}) => {
    try {
      const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/nan/recusado`, body, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  deleteById: async (id) => {
    return await axios.delete(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/nan/recusado/${id}`
    );
  },
  
};
